import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "preview-block" }
const _hoisted_2 = { class: "preview-header" }
const _hoisted_3 = { class: "preview-container" }
const _hoisted_4 = { class: "iframe-box" }
const _hoisted_5 = { class: "iframe-box-header" }
const _hoisted_6 = {
  key: 0,
  class: "concept-name"
}
const _hoisted_7 = { class: "concept-message" }
const _hoisted_8 = {
  key: 1,
  class: "concept-name"
}
const _hoisted_9 = {
  key: 2,
  class: "path-name"
}
const _hoisted_10 = {
  key: 3,
  class: "path-name"
}
const _hoisted_11 = { class: "iframe-content" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

import { mdiClose } from "@mdi/js";
import { PropType } from "vue";

import { useUIContentStore } from "@/stores/ui-content.store";

import { AssetLocation } from "@/models/assets.model";
import { ContentStructureSection } from "@/models/content-structure.model";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPreview',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  },
  path: {
    type: Object as PropType<AssetLocation>
  }
},
  setup(__props) {

const uiContentStore = useUIContentStore();



const getContentLink = (): string => {
  if (uiContentStore.fileLocationForPreview) {
    if (uiContentStore.fileLocationForPreview.includes("youtu")) {
      const linkWithoutPostfix =
        uiContentStore.fileLocationForPreview.split("&")[0];
      const prefixesToSearch = [
        "watch?v=",
        "v/",
        "watch?vi=",
        "vi/",
        "e/",
        "?v="
      ];
      const searchValue = prefixesToSearch.find((element: string) => {
        return linkWithoutPostfix.includes(element);
      });
      if (linkWithoutPostfix.includes("youtube")) {
        return searchValue
          ? linkWithoutPostfix.replace(searchValue, "embed/")
          : "";
      }
      if (linkWithoutPostfix.includes("youtu.be")) {
        return (
          "https://www.youtube.com/embed/" +
          linkWithoutPostfix.split("https://youtu.be")[1]
        );
      }
    }
    if (uiContentStore.fileLocationForPreview.includes("onedrive")) {
      return uiContentStore.fileLocationForPreview.replaceAll("&amp;", "&");
    }
    return uiContentStore.fileLocationForPreview;
  }
  return "";
};
const checkIfExternalContentIsImage = (): boolean => {
  const contentLink = getContentLink();
  return !!contentLink && contentLink.match(/\.(jpeg|jpg|gif|png)$/) !== null;
};

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", null, " Preview Mode: Media Content ", -1)),
      _createElementVNode("button", {
        class: "btn-3",
        title: "Close Media Content Preview",
        "aria-label": "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closePreview'))),
        "data-testing": "close-right-sidebar"
      }, [
        _createVNode(_component_SVGIcon, {
          path: _unref(mdiClose),
          type: "is-white",
          size: "24"
        }, null, 8, ["path"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (__props.section.concepts[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(__props.section.concepts[0].name) + " ", 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.section.name), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.section.name), 1)),
          (__props.path)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(__props.path.name) + " ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "path-message" }, " Guided Learning Loop ", -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, " Guided Learning Loop "))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (checkIfExternalContentIsImage())
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "content",
                src: getContentLink(),
                alt: "image"
              }, null, 8, _hoisted_12))
            : (_openBlock(), _createElementBlock("iframe", {
                key: 1,
                class: "content",
                src: getContentLink()
              }, null, 8, _hoisted_13))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "iframe-footer" }, [
          _createElementVNode("button", {
            disabled: true,
            class: "button"
          }, " Next")
        ], -1))
      ])
    ])
  ]))
}
}

})